// @ts-strict-ignore
import { createPayloadAction } from '../../redux/helpers/redux-helpers'
import { FsCore } from '../../types/fs-core'
import { readCookieRaw } from '../../utils/cookies'
import uuidv4 from '../../utils/guid'

const { __FS_API_URL__ } = global

export interface SetProductTablePayload {
  id: string
  productTable: FsCore.ESProductTableState
}
export const setProductTable = createPayloadAction<SetProductTablePayload>('SET_PRODUCT_TABLE')
export interface UpdateProductTablePayload {
  id: string
  pageOffset: number
  selectedSort: FsCore.SortState
}
export const updateProductTable =
  createPayloadAction<UpdateProductTablePayload>('UPDATE_PRODUCT_TABLE')

export interface UpdateProductTableEligibilityPayload {
  id: string
  eligibilityResults: any
}

export interface UpdateEligibilityPayload {
  eligibilityResults: any
  scoredEligibilityIds: any
}

export const updateProductTableEligibility =
  createPayloadAction<UpdateProductTableEligibilityPayload>('UPDATE_PRODUCT_TABLE_ELIGIBILITY')

export const updateEligibility = createPayloadAction<UpdateEligibilityPayload>('UPDATE_ELIGIBILITY')

export const setIsLoading = createPayloadAction<{ id: string; isLoading: boolean }>(
  'SET_IS_LOADING',
)
export const setPageOffset = createPayloadAction<{ id: string; pageOffset: number }>(
  'SET_PAGE_OFFSET',
)

export const eligibilityRequest = (
  brand: string,
  showZeroPercent: boolean = true,
  minEligibility: number = 0,
  maxEligibility: number = 100,
  emailResultsToken?: string,
) => {
  return fetch(
    `${__FS_API_URL__}/eligibility?brand=${brand}&${
      emailResultsToken ? `emailToken=${emailResultsToken}` : `deviceId=${readCookieRaw('uscd')}`
    }&requestId=${uuidv4()}&zeroEligibility=${showZeroPercent}&minEligibility=${minEligibility}&maxEligibility=${maxEligibility}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

// eslint-disable-next-line no-magic-numbers
const ONE_DAY = 24 * 60 * 60 * 1000
export const staleResults = (results: FsCore.EligibilityResults) =>
  Date.now() - results.createdDate >= ONE_DAY
